var SENTRY_RELEASE;SENTRY_RELEASE={name: "RBF", version: "1.0.0"};